import {createRef, useRef} from 'react';

export const useDynamicRefs = (size = 1) => {
    return useRef([...Array(size)].map(() => createRef<HTMLDivElement>()));
};
